import { UcButton } from './uc-button.js';
import { safeDefine } from '../../utils/define-element';

safeDefine('uc-button', UcButton);
